import React, { Component } from 'react';
import { Link } from 'react-router-dom';


// THIS IS USED FOR WIDGETS
export class StyleOne extends Component {
    render() {
        const { tag, serviceDesc, buttonText, bgcolor, imag, url } = this.props
        return (
            <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6 rel-sev center-aligned">
                <div className={"card"}>
                    {/* <div className="column black-text"> col-6 col-md-3  + bgcolor*/}
                        {/* <div className="card-body"> */}
                        <div className="text-hold">
                            <p className="widget-heading">{serviceDesc}</p>
                        </div>
                            {/* <img src={imag} alt="widget" className='widget-illustration' /> */}
                            <Link to={url} className="gray-bordered-button-sm">{buttonText}</Link>
                        {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        );
    }
}

export class StyleTwo extends Component {
    render() {
        const { tag, serviceDesc, buttonText, bgcolor } = this.props
        return (
            <div className="col-6 col-md-3 rel-sev">
                <div className={"card more-half-card service-card " + bgcolor}>
                    <div className="column white-text">
                        <span className='text-uppercase'>{tag}</span>
                        <div className="card-body turquoise-bg">
                            <p className="block-heading">{serviceDesc}</p>

                            <Link to="/" className="white-button-sm">{buttonText}</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export class StyleThree extends Component {
    render() {
        const { tag, serviceDesc, buttonText, bgcolor, imag, url } = this.props
        return (
            <div className="col-lg-1 col-md-3 col-sm-2 col-xs-3 rel-sev center-aligned">
                <div className={"card"}>
                </div>
            </div>
        );
    }
}